import { SelectOption } from '@factorialco/deprecated-design-system'
import sortBy from 'lodash/sortBy'

import { employeeStatusOptions } from 'modules/core/components/EmployeeMultiFilters/commonOptions'
import {
  legalEntityOptions,
  locationOptions,
  teamOptions,
} from 'modules/core/components/MultiFilters/commonOptions'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'
import { Collection, Model } from 'modules/core/lib/mobx-rest'

import { workAreaOptionName } from 'modules/locations/store/collections/locations'
import workAreas from 'modules/locations/store/collections/workAreas'
import type WorkArea from 'modules/locations/store/models/WorkArea'

function sortedBy<T extends Model = any>(propName: string, toSort: Collection<T>) {
  return sortBy<T>(toSort.models, (model: T) => model.attributes[propName])
}

function workAreaOptions() {
  return sortedBy<WorkArea>('location_id', workAreas).map((workArea) => ({
    value: workArea.attributes.id,
    label: workAreaOptionName(workArea),
  }))
}

const filterFields = async (statusOptions: SelectOption[]): Promise<FilterOption[]> => [
  {
    label: i18n.t('filters.multi_filters.employee_status'),
    value: 'employee_status',
    type: 'equal_choice',
    options: await employeeStatusOptions(),
  },
  {
    label: i18n.t('filters.multi_filters.shift_status'),
    value: 'status',
    type: 'single_choice',
    options: statusOptions,
    customAction: true,
    hideOnAdvanced: true,
  },
  {
    label: i18n.t('filters.multi_filters.shift_location'),
    value: 'shift_location',
    type: 'equal_choice',
    options: await locationOptions(),
    customAction: true,
  },
  {
    label: i18n.t('filters.multi_filters.shift_work_area'),
    value: 'shift_work_area',
    type: 'equal_choice',
    options: await workAreaOptions(),
    customAction: true,
  },
  {
    label: i18n.t('filters.multi_filters.employee'),
    value: 'employee_name',
    type: 'string',
  },
  {
    label: i18n.t('filters.multi_filters.employee_workplace'),
    value: 'location',
    type: 'single_choice',
    options: await locationOptions(),
  },
  {
    label: i18n.t('filters.multi_filters.team'),
    value: 'team',
    type: 'single_choice',
    options: await teamOptions(),
  },
  {
    label: i18n.t('filters.multi_filters.legal_entity'),
    value: 'legal_entity',
    type: 'single_choice',
    options: await legalEntityOptions(),
  },
]

export default filterFields
